import { render, staticRenderFns } from "./power-data.vue?vue&type=template&id=08938cdc&scoped=true&"
import script from "./power-data.vue?vue&type=script&lang=js&"
export * from "./power-data.vue?vue&type=script&lang=js&"
import style0 from "./power-data.vue?vue&type=style&index=0&id=08938cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08938cdc",
  null
  
)

export default component.exports